import uuid from 'uuid/v4'
/**
 * uuid v4 去除"-"
 */
export function uuidWithoutLine(){
    return uuid()
}
